export interface IGpsStatusRequest {
    id: number,
    markStatus: number,
    trackingNumberType: number,
    outboundTrackingNumber: string,
    returnTrackingNumber: string,
    gpsLink: string,
    gpsNumber: number,
    gpsComments: string
}